/* Modified version if brighttalk player (adds an id to the iframe to allow multiple instances) */
"use strict";

function EmbedQueryStringBuilder() {
  this.constructQuery = function(e, t) {
    var a = this.getDeepLink(e),
      n = a || t.commid,
      i = [],
      r = e.match("defaultTab=(upcoming|recorded)");
    return n && i.push("commid=" + n), t.categories && i.push("categories=" + t.categories), t.inlineContent && i.push("inline=" + t.inlineContent), t.track && i.push("track=" + encodeURIComponent(t.track)), t.realmToken && i.push("realmToken=" + encodeURIComponent(t.realmToken)), !0 !== t.noChannel && "portalplayer" !== t.displayMode || i.push("showChannelList=false"), !0 !== t.autoPlay && "true" !== t.autoPlay || i.push("autoPlay=true"), r ? i.push("defaultTab=" + r[1]) : t.defaultTab && i.push("defaultTab=" + t.defaultTab), i.length ? "?" + i.join("&") + "&b=" + Math.floor(1e5 * Math.random()) : "?b=" + Math.floor(1e5 * Math.random())
  }, this.getDeepLink = function(e) {
    var t = e.match(/commid=([\d]+)(\&|#|$)/i);
    return t ? t[1] : ""
  }
}

function IframeGenerator(id) {
  this.iframe_id = id;
  this.fallbackLinkSettings = {}, this.findIframe = function(e) {
    for (var t, a = document.getElementsByTagName("iframe"), n = 0, i = a.length; n < i; n++) a[n].contentWindow === e && (t = a[n]);
    return t
  }, this.onIframeReady = function(t) {
    var e, a, n, i = this.findIframe(t.source);
    if (this.initialised = !0, Object.values(this.environments).some(function(e) {
      return e === t.origin
    })) {
      try {
        e = JSON.parse(t.data)
      } catch (r) {}
      if (e && e.body && e.body["player-state"]) switch (e.body["player-state"]) {
        case "BTembed:iframe-ready":
          a = {
            message: "embedURLSet",
            embedURL: window.location.toString()
          }, i.contentWindow.postMessage(JSON.stringify(a), "*");
          break;
        case "user-interaction":
          i.scrollIntoView();
          break;
        case "player-height-changed":
          !this.data.standalone || "auto" !== this.data.height && !0 !== this.data.handleEvents || (n = e.body.payload, i.height = n);
          break;
        case "channel-details":
          this.fallbackLinkSettings.channelDetails = e.body.payload, this.modifyFallbackLink()
      }
    }
  }, this.bootstrap = function(e) {
    var t = this;
    this.data = this.parseEmbedProperties(), this.newFrame = this.createIFrame(this.data, e), this.initialised || window.addEventListener && window.addEventListener("message", function(e) {
      t.onIframeReady(e)
    }, !1), this.renderIFrame(this.newFrame)
  }, this.selectElementByClass = function(e) {
    return document.getElementById(this.iframe_id).getElementsByClassName ? document.getElementById(this.iframe_id).getElementsByClassName(e)[0] : document.getElementById(this.iframe_id).querySelectorAll("." + e)[0]
  }, this.parseEmbedProperties = function() {
    var e;
    return this.embedTag = this.selectElementByClass("jsBrightTALKEmbed"), this.configTag = this.selectElementByClass("jsBrightTALKEmbedConfig"), this.embedWrapper = this.selectElementByClass("jsBrightTALKEmbedWrapper"), (e = this.configTag ? JSON.parse(this.configTag.innerHTML) : JSON.parse(this.embedTag.innerHTML)).baseUrl = this.validateEnvironment(e.environment), e.standalone = "standalone" === e.displayMode || "portalplayer" === e.displayMode || "authenticator" === e.application, e.height || "channelList" === e.displayMode || (e.height = "auto"), "auto" === e.height && "channelList" === e.displayMode && (e.height = "2000px"), this.correctCase(e, "commid")
  }, this.correctCase = function(e, t) {
    for (var a in e) a.match(new RegExp(t, "i")) && (e[t] = e[a]);
    return e
  }, this.environments = {
    local: "https://players.local.brighttalk.net",
    int01: "https://www.int01.brighttalk.net",
    int02: "https://www.int02.brighttalk.net",
    int03: "https://www.int03.brighttalk.net",
    int04: "https://www.int04.brighttalk.net",
    int05: "https://www.int05.brighttalk.net",
    test01: "https://www.test01.brighttalk.net",
    stage: "https://www.stage.brighttalk.net",
    prod: "https://www.brighttalk.com"
  }, this.validateEnvironment = function(e) {
    var t = "prod",
      a = e ? e.toLowerCase() : t;
    return this.environments[a] || this.environments[t]
  }, this.getViewTemplate = function(e) {
    var t = {
      channelList: "/channel/${channelId}/channellist",
      playerWithChannel: "/channel/${channelId}/webcast/${commid}/play",
      standalone: "/channel/${channelId}/webcast/${commid}/standalone",
      portalplayer: "/channel/${channelId}/webcast/${commid}/portalplayer",
      authenticator: "/channel/${channelId}/webcast/${commid}"
    };
    return t[e] || t.channelList
  }, this.instantiateTemplate = function(e, t, a) {
    return e.replace("${channelId}", t.channelId).replace("${commid}", a.getDeepLink(document.URL) ? a.getDeepLink(document.URL) : t.commid)
  }, this.createIFrame = function(e, t) {
    var a = e.application && "default" !== e.application ? this.getViewTemplate(e.application) : e.displayMode ? this.getViewTemplate(e.displayMode) : this.getViewTemplate("channelList"),
      n = this.instantiateTemplate(a, e, t),
      i = e.application && "default" !== e.application ? "/application/" + e.application : null,
      r = e.language || "en-US",
      s = e.theme || "default",
      l = t.constructQuery(document.URL, e),
      o = document.createElement("iframe");
    return this.src = i ? e.baseUrl + "/service/player/" + r + "/theme/" + s + i + n : e.baseUrl + "/service/player/" + r + "/theme/" + s + n + l, o.width = e.width || "100%", o.height = "auto" === e.height ? "600px" : e.height || "2000px", o.scrolling = "no", o.setAttribute("frameBorder", "0"), o.setAttribute("allowtransparency", "true"), o.setAttribute("allowfullscreen", "true"), o.setAttribute("id", this.iframe_id), o.setAttribute("class", "jsPlayer"), o.style.overflow = "hidden", o
  }, this.renderIFrame = function(e) {
    this.embedWrapper ? this.embedWrapper.insertBefore(e, this.embedTag) : this.embedTag.parentNode.insertBefore(e, this.embedTag), e.src = this.src
  }, this.escapeHtml = function(e) {
    var t = document.createElement("div");
    return t.appendChild(document.createTextNode(e)), t.innerHTML
  }, this.modifyFallbackLink = function() {
    var e = this.selectElementByClass("BTfallback");
    e && e.remove();
    var t, a = this.selectElementByClass("jsBrightTALKEmbedWrapper");
    "included" === this.fallbackLinkSettings.channelDetails.searchVisibility && "portalplayer" !== this.data.displayMode && "authenticator" !== this.data.application && a && !this.data.excludeFallbackLink && (t = '<a href="' + this.data.baseUrl + "/channel/" + this.data.channelId + '" style="color:#999; text-decoration: none;" target="_blank" >' + this.escapeHtml(this.fallbackLinkSettings.channelDetails.title) + "</a>", a.insertAdjacentHTML("beforeend", '<div class="BTfallback" style="overflow: hidden; padding: 4px 0px 2px 0px; color:#999 !important; font-size:13px !important;">' + t + ' | <a href="https://www.brighttalk.com" style=" text-decoration: none; display: inline-block; color:#999;" target="_blank" >BrightTALK</a></div>'))
  }
}
Object.values || (Object.values = function(t) {
  return Object.keys(t).map(function(e) {
    return t[e]
  })
}), [Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach(function(e) {
  e.hasOwnProperty("remove") || Object.defineProperty(e, "remove", {
    configurable: !0,
    enumerable: !0,
    writable: !0,
    value: function() {
      null !== this.parentNode && this.parentNode.removeChild(this)
    }
  })
});
//# sourceMappingURL=player-embed.js.map
